// eslint-disable-next-line no-shadow
export enum PreloadChannels {
	OPEN_HOME_TAB = 'open-home-tab',
	OPEN_NEW_TAB = 'open-new-tab',
	SWITCH_TAB = 'switch-tab',
	TAB_CREATED = 'tab-created',
	CLOSE_TAB = 'close-tab',
	OPEN_EXTERNAL_LINK = 'open-external-link',
	SEND_TOKEN = 'send-token',
	UPDATE_DOWNLOAD_PROGRESS = 'update-download-progress',
}
